import { RefObject } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
	useDetailTableHandlers as useCommonDetailTableHandlers,
} from 'src/hooks/useDetailTableHandlers';
import { useCodeSearch } from 'src/hooks/useCodeSearch';
import { CodeSearchModalProps } from 'src/types/code-search';
import { createModuleConfig } from 'src/utils/detail-table/detailTableUtils';
import {
	calcBalance,
	MST2020_R01Dto,
} from '../Dto_MST2020_R01';

interface UseMST2020_R01CellChangeProps {
	MST2020_R01List: MST2020_R01Dto[];
	originalMST2020_R01List: MST2020_R01Dto[];
	updateMST2020_R01List: (
		index: number,
		data: MST2020_R01Dto,
	) => void;
	gridRef: RefObject<
		AgGridReact<MST2020_R01Dto> | null
	>;
	setCodeSearchModalProps: (props: CodeSearchModalProps) => void;
}

export function useMST2020_R01CellChange({
	MST2020_R01List,
	originalMST2020_R01List,
	updateMST2020_R01List,
	gridRef,
	setCodeSearchModalProps,
}: UseMST2020_R01CellChangeProps) {
	const { searchExactCode } = useCodeSearch({});
	const MST2020Config =
		createModuleConfig.MST2020();

	const fieldConfigWithSearch = {
		...MST2020Config.fieldConfig,
		codeSearchFields: {
			...MST2020Config.fieldConfig
				.codeSearchFields,
			customCd: {
				...MST2020Config.fieldConfig
					.codeSearchFields!.customCd,
				searchFunction: (
					code: string,
					onSuccess?: (
						item: unknown,
					) => void,
				) =>
					searchExactCode(
						'customer',
						code,
						onSuccess,
					),
				canOpenModal: (
					row: MST2020_R01Dto,
				) => !!row?.inserted,
			},
		},
	};

	const calculateAmount = (
		data: MST2020_R01Dto,
	): MST2020_R01Dto => ({
		...data,
		balanceAmt: calcBalance(data),
	});

	return useCommonDetailTableHandlers<MST2020_R01Dto>({
		detailList: MST2020_R01List,
		updateDetailList: updateMST2020_R01List,
		originalDetailList:
			originalMST2020_R01List,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig:
			MST2020Config.codeSearchConfig,
		calculateAmount,
	});
}
